import {getOpenApiJsonAsString} from "./openap-utils.js";

function createButton({ onClick, id }) {
    const btn = document.createElement("button");
    btn.textContent = "Copiar OpenAPI JSON";
    btn.id = id;
    btn.className = "m-btn primary thin-border";
    btn.style.marginLeft = "6px";
    btn.onclick = onClick;
    return btn;
}

export function injectCopyButtons({ rapiDocEl, details, copyToClipboard }) {
    const shadowRoot = rapiDocEl?.shadowRoot;
    if (!shadowRoot) return;

    const tags = details?.tags ?? [];
    tags.forEach((tag) => {
        (tag.paths ?? []).forEach((path) => {
            const apiReq = shadowRoot.querySelector(`api-request[path="${path.path}"]`);
            if (!apiReq?.shadowRoot) return;

            const buttonId = `copy-openapi-${path.method}-${path.path}`;
            if (apiReq.shadowRoot.getElementById(buttonId)) return;

            const jsonStr = getOpenApiJsonAsString(details, path);
            const btn = createButton({
                id: buttonId,
                onClick: () => copyToClipboard(jsonStr),
            });

            const container = apiReq.shadowRoot.querySelector('[part="wrap-request-btn"]');
            if (container) container.appendChild(btn);
        });
    });
}